import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getAggregateSales, getAggregateInventory } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportAggregateInventory } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import WithRouter from 'custom/withRouter';

class InventoryBranches extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,

            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.chartDataState = [];
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `InventoryBranchesBeginDate`);

    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryBranchesBeginDate`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {

        this.filter();
        this.setState({ showBody: true });

    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        this.props.getAggregateInventory({ beginDate });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    render() {


        return (
            <Grid headerContent={reportAggregateInventory}>
                <PageHeader 
                        title={LOOKUP.report.aggregateInventory.text}
                        icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-inventory-sales-report" />}
                        description={LOOKUP.report.aggregateInventory.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} groupOptions={this.props.groupOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body aggregateInventory={this.props.aggregateInventory} branchOptions={this.props.brachOptions} beginDate={this.props.beginDate} />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    let groupOptions = [
        {
            text: "Year", value: "1"
        },
        {
            text: "Month", value: "2"
        },
        {
            text: "Day", value: "3"
        }
    ]
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        aggregateSales: state.reports.aggregateSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.InventoryBranchesBeginDate,
        endDate: state.form.InventoryBranchesEndDate,
        group: state.form.AggregateSalesGroup,
        aggregateInventory: state.reports.aggregateInventory,
        groupOptions
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAggregateSales: model => dispatch(getAggregateSales(model)),
        getAggregateInventory: model => dispatch(getAggregateInventory(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(InventoryBranches));